import {
  ROID_OT_SELECTED_GENERAL_VIEW,
  ROID_OT_SELECTED_GENERAL_VIEW_RESET,
} from '../../actions/ui/roidOTSelectedGeneralView';

export const initialState = {
  type: null,
  roid: null,
  id: null,
  capitol: null,
  subCapitol: null,
  // Navigation metadata for breadcrumb context (Redux backup for sessionStorage)
  origin: null,
  parentOrderId: null,
  parentRoid: null,
  entityRoid: null,
};

type actionType = {
  type: string;
  payload: {
    type: string;
    roid: string;
    id: string;
    capitol?: string;
    subCapitol?: string;
    origin?: string | null;
    parentOrderId?: string | null;
    parentRoid?: string | null;
    entityRoid?: string | null;
  };
};

export default function roidOTSelected(
  state = initialState,
  { type, payload }: actionType
) {
  switch (type) {
    case ROID_OT_SELECTED_GENERAL_VIEW:
      return {
        ...state,
        type: payload.type,
        roid: payload.roid,
        id: payload.id,
        capitol: payload.capitol || null,
        subCapitol: payload.subCapitol || null,
        // Navigation metadata
        origin: payload.origin || null,
        parentOrderId: payload.parentOrderId || null,
        parentRoid: payload.parentRoid || null,
        entityRoid: payload.entityRoid || null,
      };
    case ROID_OT_SELECTED_GENERAL_VIEW_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
